import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
} from 'react-router-dom';
import NdbkAPI from '../ndbk-api'
// import { SocketProvider } from 'socket.io-react'; #SOCKET_IO
// import io from 'socket.io-client' #SOCKET_IO
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import configureStore from '../store'
import PrivateRoute from './PrivateRoute';
import RouteRecorder from './RouteRecorder'

// pages
import NotFoundPage from '../pages/NotFoundPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import LandingPage from '../pages/LandingPage';
import BlogPage from '../pages/BlogPage';
import RoadmapPage from '../pages/RoadmapPage';
// import PricingPage from '../pages/PricingPage';
import FeaturesPage from '../pages/FeaturesPage';
import TermsOfServicePage from '../pages/TermsOfServicePage.js';
import PaymentPage from '../pages/PaymentPage';
// import MobileUnsupportedPage from '../pages/MobileUnsupportedPage';
// app pages
import ProfilePage from './ProfilePage';
import NodebookPage from './NodebookPage';
import SearchPage from './SearchPage';
import NotificationsPage from './NotificationsPage';
import GroupPage from './GroupPage';
import SettingsPage from './SettingsPage';
import DashboardPage from './DashboardPage';
// import DashboardPage from '../pages/DashboardPage';
// import SettingsPage from '../pages/SettingsPage';
// test pages
// import PlaygroundPage from '../pages/test/PlaygroundPage';
// import FlowPage from '../pages/test/FlowPage';
// import NdbkPage from '../pages/test/NdbkPage';
// import WebGLCanvasRenderer from '../pages/test/WebGLCanvasRenderer';
// import WebGLRenderer from '../pages/test/WebGLRenderer';

class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            auth: null,
        }

        // TODO mobile/desktop
        // TODO browser version, type
        // TODO redirect to original path

        //this.socket = io(`https://nodebook.io`, {secure:true}) #SOCKET_IO
        this.store = createStore(configureStore)
    }
    componentWillMount() {
        this.checkAuth();
        // this.socket.connect(); #SOCKET_IO
    }
    componentWillUnmount() {
        // this.socket.disconnect(); #SOCKET_IO
    }
    // TODO remove cuz it's deprecated practically
    setAuth = (val = true, cb = null) => {
        this.setState({
            auth: {
                ...this.state.auth, success: val
            }
        }, () => {
            cb();
        });
    }
    // TODO remove cuz it's deprecated practically
    adjustAuthUser = (props) => {
        this.setState({
            auth: {
                ...this.state.auth, user: { ...this.state.auth.user, ...props }
            }
        })
    }

    checkAuth = (cb) => {
        let setAuth = (data => this.setState({ auth: data }, cb))
        NdbkAPI.auth.check(setAuth, setAuth)
    }
    render() {

        if (this.state.auth === null) {
            return (null);
        }
        const PrivateRouteProps = {
            auth: {
                ...this.state.auth,
                setAuth: this.setAuth,
                adjustAuthUser: this.adjustAuthUser,
                checkAuth: this.checkAuth
            },
        }

        return (
            // <SocketProvider socket={this.socket}> #SOCKET_IO
            <Provider store={this.store}>
                <Router >
                    <RouteRecorder>
                        <Switch>
                            {/* MAIN SITE */}
                            <Route path="/landing" render={() => <LandingPage {...PrivateRouteProps} />} />
                            <Route path="/blog" render={() => <BlogPage {...PrivateRouteProps} />} />
                            <Route path="/roadmap" render={() => <RoadmapPage {...PrivateRouteProps} />} />
                            {/*<Route path="/pricing" render={()=><PricingPage {...PrivateRouteProps}/>} />*/}
                            <Route path="/features" render={() => <FeaturesPage {...PrivateRouteProps} />} />
                            <Route path="/privacy" render={() => <PrivacyPolicyPage {...PrivateRouteProps} />} />
                            <Route path="/terms-of-service" render={() => <TermsOfServicePage {...PrivateRouteProps} />} />
                            <Route path="/donate" render={() => <PaymentPage {...PrivateRouteProps} />} />

                            {/* TESTING */}
                            {/*<Route path="/ndbk/:id" render={()=><NdbkPage {...PrivateRouteProps}/>} />
                        <Route path="/playground" render={()=><PlaygroundPage {...PrivateRouteProps}/>} />
                        <Route path="/webgl" render={()=><WebGLRenderer />} />
                        <Route path="/flow" render={()=><FlowPage />} />
                        <Route path="/webglcanvas" render={()=><WebGLCanvasRenderer />} />*/}

                            {/* APP */}
                            <PrivateRoute exact path="/dashboard/:tab?" component={DashboardPage} {...PrivateRouteProps} />
                            <PrivateRoute path="/search/:type/:query?" component={SearchPage} noheader={(this.isMobile) ? true : false} {...PrivateRouteProps} />
                            <PrivateRoute path="/user/:username/:tab?" component={ProfilePage} noheader={(this.isMobile) ? true : false}  {...PrivateRouteProps} />
                            {/*<PrivateRoute path="/messages/with/:id" component={MessagesPage} {...PrivateRouteProps} />
                        <PrivateRoute path="/messages" component={MessagesPage} {...PrivateRouteProps} />*/}
                            <PrivateRoute path="/notifications" component={NotificationsPage} noheader={(this.isMobile) ? true : false}  {...PrivateRouteProps} />
                            <PrivateRoute path="/settings/:tab?" component={SettingsPage} noheader={(this.isMobile) ? true : false}  {...PrivateRouteProps} />
                            <PrivateRoute path="/group/:id/:tab?" component={GroupPage} noheader={(this.isMobile) ? true : false}  {...PrivateRouteProps} />
                            {/*<PrivateRoute path="/organization/:id/:tab?" component={OrganizationPage} {...PrivateRouteProps} />*/}

                            <Route path="/nodebook/:id/compare/:clone_id" noheader render={() => { return <NodebookPage {...PrivateRouteProps} /> }} /*component={NodebookPage} {...PrivateRouteProps}*/ />
                            <Route path="/nodebook/:id/t/:transformations" noheader render={() => { return <NodebookPage {...PrivateRouteProps} /> }} /*component={NodebookPage} {...PrivateRouteProps}*/ />
                            <Route path="/nodebook/:id" noheader render={() => { return <NodebookPage {...PrivateRouteProps} /> }} /*component={NodebookPage} {...PrivateRouteProps}*/ />
                            <Route path="/n/:id" noheader render={() => { return <NodebookPage {...PrivateRouteProps} /> }} /*component={NodebookPage} {...PrivateRouteProps}*/ />
                            <PrivateRoute path="/" exact component={DashboardPage}  {...PrivateRouteProps} />

                            <Route render={() => <NotFoundPage title="404" message="Page not found" />} />
                        </Switch>
                    </RouteRecorder>
                </Router>
            </Provider>
            // </SocketProvider> #SOCKET_IO
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js